import {MutatingDots} from 'react-loader-spinner'
import React from 'react'
const Loading: React.FC = () => <MutatingDots
color="#5EBDDB"
secondaryColor="#043A5C"
height={150}
width={150}/>

export default Loading
